import { render } from "./VueScrollingTable.vue?vue&type=template&id=4c74723c"
import script from "./VueScrollingTable.vue?vue&type=script&lang=js"
export * from "./VueScrollingTable.vue?vue&type=script&lang=js"

import "./VueScrollingTable.vue?vue&type=style&index=0&id=4c74723c&lang=css"

import exportComponent from "/media/doevent/Data/doevent/project/pmb/db/de-db-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__